const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;

export const registerPushSubscription = async () => {
  const registration = await navigator.serviceWorker.ready;

  if (vapidKey) {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });

    console.log("Push Subscription:", subscription);
    return subscription;
  }
};

// Base64 → Unit8Arrayの変換処理
function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    output[i] = rawData.charCodeAt(i);
  }
  return output;
}
